import BackgroundFileTranslationsRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileTranslationsRequest";

export default class BackgroundTranslationViewModel {
	id?: string = null;
	langCode?: string = "";
	name?: string = "";

	constructor(obj?: Partial<BackgroundTranslationViewModel>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}

	toServerModel(): BackgroundFileTranslationsRequest {
		return new BackgroundFileTranslationsRequest({
			Id: this.id,
			LangCode: this.langCode,
			Name: this.name,
		});
	}
}
